import { __decorate } from "tslib";
import { attr, customElement } from "@microsoft/fast-element";
import { TextAreaTemplate as template, TextArea } from "@microsoft/fast-foundation";
import { TextAreaStyles as styles } from "./text-area.styles";
/**
 * The FAST Text Area Custom Element. Implements {@link @microsoft/fast-foundation#TextArea},
 * {@link @microsoft/fast-foundation#TextAreaTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fast-text-area\>
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/delegatesFocus | delegatesFocus}
 */
let FASTTextArea = class FASTTextArea extends TextArea {
    /**
     * @internal
     */
    connectedCallback() {
        super.connectedCallback();
        if (!this.appearance) {
            this.appearance = "outline";
        }
    }
};
__decorate([
    attr
], FASTTextArea.prototype, "appearance", void 0);
FASTTextArea = __decorate([
    customElement({
        name: "fast-text-area",
        template,
        styles,
        shadowOptions: {
            delegatesFocus: true,
        },
    })
], FASTTextArea);
export { FASTTextArea };
/**
 * Styles for TextArea
 * @public
 */
export const TextAreaStyles = styles;
